<script setup lang="ts">
  import { MpDivider, MpLoadingContainer } from '@borg/ui';

  const { t } = useI18n();

  usePageHead({
    pageName: t('ADVICES_PAGE.TITLE'),
    description: t('ADVICES_PAGE.DESCRIPTION'),
    isMainNavPage: true,
  });

  const { data: articles, pending, error, refresh } = await articlesRepository.getMany();
</script>

<template>
  <MpLoadingContainer
    :is-loading="pending"
    :has-error="!!error"
    @reload="refresh"
  >
    <div
      v-for="(block, idx) in articles ?? []"
      :key="block.title"
    >
      <ArticleBlock :data="block" />
      <MpDivider
        v-if="!!articles && idx < articles.length - 1"
        margin="lg"
      />
    </div>
  </MpLoadingContainer>
</template>
